export enum DataHooks {
  TIME_PICKER = 'timepicker',
  SELECTED_DATE = 'selected-date',
  LOADER = 'loader',
  SR_ONLY_ANNOUNCEMENT = 'time-picker-sr-only-announcement',
  SR_ONLY_SELECTED_DATE = 'sr-only-selected-date',
}
